import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, History, Plus, TrendingDown, User } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';
import OfflineIndicator from '@/components/common/OfflineIndicator';
import './AppLayout.css';

type AppLayoutProps = {
  children: React.ReactNode;
};

export default function AppLayout({ children }: AppLayoutProps) {
  const { user } = useAuth();
  const location = useLocation();
  const isLogWeightPage = location.pathname === '/log';

  return (
    <div className="app-layout">
      <OfflineIndicator />
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <header className="app-header">
        <div className="brand">
          <TrendingDown className="brand-icon" size={36} strokeWidth={2} />
          <span className="brand-text">tracker</span>
        </div>
        {user && (
          <NavLink to="/profile" className="header-profile-button" title="Profile">
            <User className="profile-icon" size={28} strokeWidth={2} />
          </NavLink>
        )}
      </header>
      <main id="main-content" className="app-main">
        {children}
      </main>
      {user && (
        <>
          <nav className="app-footer-nav">
            <NavLink to="/dashboard" className="footer-nav-item">
              <LayoutDashboard className="footer-nav-icon" size={24} strokeWidth={2} />
              <span className="footer-nav-label">Dashboard</span>
            </NavLink>
            <NavLink to="/progress" className="footer-nav-item">
              <TrendingDown className="footer-nav-icon" size={24} strokeWidth={2} />
              <span className="footer-nav-label">Progress</span>
            </NavLink>
            <NavLink to="/history" className="footer-nav-item">
              <History className="footer-nav-icon" size={24} strokeWidth={2} />
              <span className="footer-nav-label">History</span>
            </NavLink>
          </nav>
          {!isLogWeightPage && (
            <NavLink to="/log" className="fab-button" title="Log new weight entry">
              <Plus className="fab-icon" size={28} strokeWidth={2.5} />
            </NavLink>
          )}
        </>
      )}
    </div>
  );
}
